import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { parseQs, tokenExchange, tokenExchangeSSO } from 'src/functions';

import LoaderComponent from './message';

const loggedIn = (accessToken, refreshToken) => accessToken && refreshToken;
const exchange = async (search, clientId) => {
  const { code, error_description: errDesc, error: err } = parseQs(search.replace('?', ''));
  const clientIdParam = clientId ? `/${clientId}` : '';
  const redirectUri = `${window.location.origin}/token${clientIdParam}`;
  const encodedRedirectUri = encodeURIComponent(redirectUri);
  if (err === 'invalid_request' && errDesc.includes('SSO')) {
    if (clientId)
      window.location.href = `https://${process.env.REACT_APP_COGNITO_DOMAIN}/login?client_id=${clientId}&response_type=code&scope=email+openid+phone+profile&redirect_uri=${encodedRedirectUri}`;
  }
  if (code && clientId) await tokenExchangeSSO(code, redirectUri, clientId);
  else if (code) await tokenExchange(code);
};

function TokenExchange({ location: { search }, match }) {
  useEffect(() => {
    window.localStorage.setItem('login_client', match?.params?.cognitoClientId);
    if (!loggedIn(localStorage.getItem('accessToken'), localStorage.getItem('refreshToken'))) {
      exchange(search, match.params.cognitoClientId);
    }
  }, [search, match.params.cognitoClientId]);

  return <LoaderComponent />;
}

TokenExchange.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default TokenExchange;
